module.exports = "../images/icons/phone.svg";